import { Link } from 'react-router-dom'
import SearchIcon from '../../../../assets/icons/searchIcon.svg?react'
import styles from './submitSearchBtn.module.css'

interface SubmitSearchBtnProps {
  onAfterNavigate?: () => void
}

export function SubmitSearchBtn({ onAfterNavigate }: SubmitSearchBtnProps) {
  return (
    <Link
      to="/advancedSearch"
      className={styles.submitSearchBtn}
      aria-label="Go to advanced search"
      onClick={onAfterNavigate}
    >
      <SearchIcon className={styles.searchIcon} aria-hidden="true" />
    </Link>
  )
}
